import { Box } from "components/box";
import React from "react";
import "./skeleton.scss";

const Skeleton = () => {
  return <Box className="skeleton" />;
};

export default Skeleton;
